import styled from 'styled-components'
import { Centered } from '../../../../components'
import { mediaQuery } from '../../../../components/utils'
import { colors } from '../../../../constants'

const Background = styled(Centered)`
    background: ${colors.greylightest};
    height: 100%;
    position: relative;
`

const Box = styled.div`
    background: ${colors.white};
    border-radius: 5px;
    box-shadow: 0px 0px 10px #0000002c;
    margin: 15px 0;
    max-width: 100%;
    overflow-y: auto;
    text-align: center;
    width: 1000px;

    ${mediaQuery.mobile(`
  margin: 0;
  `)}
`

const BackLink = styled.a`
    ${({ color }) => (color ? `color: ${color};` : `color: ${colors.blue};`)}
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    left: 0;
    padding: 20px 30px;
    position: absolute;
    text-decoration: none;
    top: 0;
`

const MediaPlaylistsDetails = styled.div`
    color: ${colors.grey};
    font-size: 15px;
    margin-left: 15px;
    text-align: left;
`

export { Background, BackLink, Box, MediaPlaylistsDetails }
